/** Тост с отменой. Удаление идёт БЕЗ диалога «вы уверены»: одно движение вместо
 *  двух, и промах стоит одного тапа.
 *
 *  Живёт двадцать секунд, а не пять: «Вернуть» — единственный путь восстановления
 *  во всём приложении, и пять секунд на решение это лимит времени на действие.
 *  Наведение и фокус останавливают отсчёт — читающему медленно он не должен
 *  утекать под руками.
 */
import { useEffect, useRef, useState } from "react";

/** Пауза по наведению — только там, где есть настоящий курсор.
 *
 *  На тачскрине «навёл» наступает от тапа, а «увёл» не наступает никогда: палец
 *  просто исчезает. Отсчёт вставал намертво, и тост «Запись удалена» оставался
 *  на экране до перезахода в приложение (случай владельца 25.10). */
const HOVERABLE = typeof window !== "undefined"
  && typeof window.matchMedia === "function"
  && window.matchMedia("(hover: hover)").matches;

export function Toast({ text, action, onAction, onHide }: {
  text: string;
  action?: string;
  onAction?: () => void;
  onHide: () => void;
}) {
  const [held, setHeld] = useState(false);
  // Свежий колбэк, не трогающий таймер. Родитель отдаёт новую стрелку на каждый
  // рендер, и пока `onHide` стоял в зависимостях, любой рендер экрана —
  // подгрузка следующей страницы, буква в поиске — запускал двадцать секунд
  // заново. На живой ленте тост не исчезал вовсе.
  const hide = useRef(onHide);
  hide.current = onHide;

  useEffect(() => {
    if (held) return;
    const t = setTimeout(() => hide.current(), 20000);
    return () => clearTimeout(t);
  }, [held]);

  const pause = HOVERABLE
    ? { onMouseEnter: () => setHeld(true), onMouseLeave: () => setHeld(false) }
    : {};

  return (
    <div role="status"
         {...pause}
         onFocusCapture={() => setHeld(true)}
         onBlurCapture={() => setHeld(false)}
         style={{ position: "fixed", left: 16, right: 16, bottom: "calc(81px + var(--tg-safe-bottom, 0px))",
                  background: "var(--surface-3)", borderRadius: "var(--r-field)",
                  padding: "14px 16px", display: "flex", alignItems: "center",
                  gap: "var(--s-4)", zIndex: 20 }}>
      <span style={{ flexGrow: 1, fontSize: "var(--f-body-s)" }}>{text}</span>
      {action && (
        <button type="button" onClick={onAction}
                style={{ background: "none", border: "none", cursor: "pointer", font: "inherit",
                         fontSize: "var(--f-body-s)", fontWeight: 600, color: "var(--accent)",
                         minHeight: 32, padding: "0 4px" }}>
          {action}
        </button>
      )}
    </div>
  );
}
